import { axiosGet } from '@/app/helpers/AxiosHelper';

export default {
  state: {
    evaluatorType: [],
    scope: {
      tree: {
        isRoot: true,
        value: "Alcances",
        children: [],
      },
      sourceNode: {},
      node: {},
    },
    evalTestId: null,
    evalTest: {},
    maintenanceId: null,
    detailId: 0
  },

  getters: {
  },

  mutations: {
    SET_EVALUATOR_TYPE(state, data) {
      state.evaluatorType = data;
    },
    SET_SCOPE_TREE(state, data) {
      state.scope.tree.children = data;
    },
    ADD_CHILD(state, data) {
      state.scope.tree.sourceNode.children.push(data);
    },
    UPDATE_NODE(state, data) {
      state.scope.tree.sourceNode.value = data.value;
    },
    DELETE_NODE(state, data) {
      console.log(state.scope.tree.sourceNode);
    },
    SET_EVAL_TEST(state, data) {
      state.evalTest = data;
    },
    SET_MAINTENANCE_ID(state, data){
      state.maintenanceId = data;
    },
    SET_DETAIL_ID(state, data){
      state.detailId = data;
    }
  },

  actions: {
    getEvaluatorType({ commit, state }) {
      const url = '/evaluator/maintenance/types';
      if (state.evaluatorType.length == 0) {
        axiosGet(url).then(res => {
          if (res.status == 200) {
            commit('SET_EVALUATOR_TYPE', res.data);
          }
        });
      }
    },

    getScopeTree({ commit, state }) {
      const url = 'scopes/tree';
      axiosGet(url).then((res) => {
        if (res.status == 200) {
          commit('SET_SCOPE_TREE', res.data);
        }
      });
    },

    addChildren({ commit, state }, data) {
      commit('ADD_CHILD', data);
    },

    updateNode({ commit, state }, data) {
      commit('UPDATE_NODE', data);
    },

    deleteNode({ commit, state }, data) {
      commit('DELETE_NODE', data);
    },

    getEvalTest({ commit, state }) {
      const url = `evaluator/documentaryEvaluation/show/${state.evalTestId}`;
      axiosGet(url).then((res) => {
        if (res.status == 200) {
          commit('SET_EVAL_TEST', res.data);
        }
      });
    },
  }
}